"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var AppBand_1 = require("../../components/globals/AppBand");
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            username: ''
        };
        _this.failed = false;
        return _this;
    }
    Login.prototype.beforeCreate = function () {
        document.title = "ログイン | 自宅でできる介護リハビリ - リハプラン";
        document.querySelector("meta[property='og:title']").setAttribute('content', "ログイン | 自宅でできる介護リハビリ - リハプラン");
        document.querySelector("meta[name='description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」のログインはこちらです。申込時に記入したメールアドレスを入力してください。");
        document.querySelector("meta[property='og:description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」のログインはこちらです。申込時に記入したメールアドレスを入力してください。");
        document.querySelector("meta[name='keywords']").setAttribute('content', "自宅でできる,介護リハビリ,ログイン,リハプラン");
        document.querySelector("link[rel='canonical']").setAttribute('href', "https://rehaplan.jp/keeprehab/login");
    };
    Login.prototype.mounted = function () {
        if (this.$login.isSignIn()) {
            this.$router.push({ path: '/keeprehab/index' });
        }
    };
    Login.prototype.onSubmit = function (event) {
        event.preventDefault();
        var self_ = this;
        self_.$login.login(self_.form.username).then(function (result) {
            self_.$router.push({ path: '/keeprehab/index' });
        }, function () {
            self_.failed = true;
        });
    };
    Login = __decorate([
        vue_property_decorator_1.Component({
            components: {
                AppBand: AppBand_1.default
            }
        })
    ], Login);
    return Login;
}(vue_property_decorator_1.Vue));
exports.default = Login;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/auth/Login.vue
// module id = qtA/
// module chunks = 1